import { Outlet } from 'react-router-dom';
import { NavBar } from '@/components/NavBar';
import { Sidebar } from '@/components/Sidebar';

export function Layout() {
  return (
    <div className="flex flex-col h-screen bg-page">
      <NavBar />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex-1 overflow-auto p-6 bg-page">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
